import { createEntityCollectionStore } from '@core/ngrx-legacy';
import { JobBoardPosting } from '@recruitee/job-boards-types';

const { actions, namespace, selectors, reducer } = createEntityCollectionStore<
  JobBoardPosting & { codename: string }
>()('JobBoardLastPosting', {
  idSelector: config => config.codename,
  customActions: _adapter => ({}),
});

export {
  actions as JobBoardLastPostingActions,
  namespace as JobBoardLastPostingNamespace,
  reducer as JobBoardLastPostingReducer,
  selectors as JobBoardLastPostingSelectors,
};
